import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import { Home } from './pages/Home';
import { ComingSoon } from './pages/ComingSoon';
import { comingSoonPages } from './data/comingSoon';

/**
 * Handles in-page anchors across route changes: scrolls to the hash target
 * (offset by the sticky header via CSS scroll-margin) or to the top.
 */
function RouteScroll() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({
          behavior: prefersReduced ? 'auto' : 'smooth',
          block: 'start'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3iiwf2oflbi38">
      <RouteScroll data-id="element-1" data-mp="3ijfu9xduvsdk" />
      <SiteLayout data-id="element-2" data-mp="3ihuyk4ft23e4">
        <Routes data-id="element-3" data-mp="3mlj6io8cn0zw">
          <Route path="/" element={<Home data-id="element-5" data-mp="3mk868ye44bdj" />} data-id="element-4" data-mp="3ml17xky7saot" />
          {comingSoonPages.map(page => <Route key={page.path} path={page.path} element={<ComingSoon page={page} data-id="element-7" data-mp="5otf64sd496" />} data-id="element-6" data-mp="3rbr9so7flver" />)}
          <Route path="*" element={<Navigate to="/" replace data-id="element-9" data-mp="2zl3bdjx5744s" />} data-id="element-8" data-mp="56qxrrj5tst" />
        </Routes>
      </SiteLayout>
    </BrowserRouter>;
}